// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__3DtpZ","icon":"EnquiryForm_icon__3sEsB","heading":"EnquiryForm_heading__QJb2l","field":"EnquiryForm_field__10PXr","error":"EnquiryForm_error__xJJeg"};